module.exports = __webpack_public_path__ + "public/img/img_6.efb42718.png";